/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementListNextResponse } from './EventSceneManagementListNextResponse';

export type EventSceneManagementListNextResponseApiRespoonse = {
    data?: EventSceneManagementListNextResponse;
    status?: EventSceneManagementListNextResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementListNextResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

